import React, {useEffect, useContext, useRef} from 'react';
import {useHistory} from 'react-router-dom'
import FormBody from "./FormBody";
import FormHeader from "./FormHeader";
import FormFooter from "./FormFooter";
import useStyles from "./styles";
import Banner from '../../Common/Banner'
import Loading from '../../Loading'
import {apiStatus} from '../../../shared/enums'
import usePrompt from '../../../shared/hooks/usePrompt'
import PriorAuthorizationContext from '../../../contexts/PriorAuthorization/PriorAuthorization.context'
import CreateSuccess from '../CreateSuccess'
import SummaryView from "../SummaryView";


export default function CreatePa() {

    const classes = useStyles();
    // keep track of api call state
    const history = useHistory()
    const contentRef = useRef();
    const { 
            create:{ currentStep }, 
            bannerProps, 
            modalState, 
            setModalState, 
            setBanner, 
            status, 
            operation, 
            fields} = useContext(PriorAuthorizationContext)

    const bannerPropsAll = {
        ...bannerProps,
        id: 'MEDCAL_RX_CREATE_PA_BANNER',
        onClick: () => setBanner({message: null}),
        style: {paddingBottom: '0.5rem'}
    }

    useEffect( () => {
        if(operation === 'create'){
            window.onbeforeunload = () => null;
        } else if(operation === 'success'){
            setModalState( {open: false, isBlocking: false} )
            window.onbeforeunload = () => null
        }
        return () => window.onbeforeunload = () => null
    // eslint-disable-next-line
    }, [operation])

    usePrompt(
        _ => {
            setModalState({
                confirm: handleCancel,
                confirmText: 'Yes, Cancel',
                confirmToolTip:  'Confirm Cancel',
                deny: closeModal,
                denyText: 'No, Go Back',
                denyToolTip: 'Go Back',
                open: true,
                title: 'Are you sure you want to cancel? All previously entered information will be lost.'
            });
            return false
        },
        modalState.isBlocking
    );

    const cancelForm = () => {
        setModalState({
            confirm: handleCancel,
            confirmText: 'Yes, Cancel',
            confirmToolTip:  'Confirm Cancel',
            deny: closeModal,
            denyText: 'No, Go Back',
            denyToolTip: 'Go Back',
            open: true,
            title: 'Are you sure you want to cancel? All previously entered information will be lost.'
        });
    }

    const closeModal = () => {
        setModalState({ open: false})
    }

    const handleCancel = () => {
        setModalState({open: false, isBlocking: false})
        history.go(-2)
    }

    const removeCompounds = cb => {
        setModalState({
            confirmText: 'Yes, Remove',
            confirmToolTip:  'Confirm Remove',
            denyText: 'No, Do Not Remove',
            denyToolTip: 'Do Not Remove',
            confirm: () => {
                closeModal()
                cb()
            },
            deny: closeModal,
            open: true,
            title: 'Are you sure you want to remove the data? All previously entered information will be lost.'
        });
    }

    const getRecord = () => {
        const records = {};
        Object.keys(fields).forEach( key => {
            records[key] = fields[key].value;
        })
        return records;
    }


    return (
        <div className={classes.rootWrapper} id='MEDCAL_RX_CREATE_STEPPER'>
            { operation === 'success' && <CreateSuccess />}
            { operation === 'create' &&
                <div className={classes.root}>
                    { status === apiStatus.LOADING && <Loading />}
                    <Banner {...bannerPropsAll}/>
                    <FormHeader data-testid='MEDCAL_RX_STEPPER_HEADER'/>
                    <div ref={contentRef}>
                        {currentStep === 6 ?
                            <SummaryView record={getRecord()} exceptions={['ndc']} operation={operation}/> :
                            <FormBody className={classes.formBody} removeCompounds={removeCompounds} />
                        }
                    </div>
                    <FormFooter handleCancel={ cancelForm } targetRef={contentRef} data-testid='MEDCAL_RX_STEPPER_FOOTER' />
                </div>
            }
        </div>
    )
}